/* Baddie Glam — la barra de compra pegada abajo se aparta del footer.
 *
 * EL PROBLEMA
 * -----------
 * En la ficha de producto hay una barra fija abajo con el precio y "Anadir al
 * carrito". Esta bien mientras lees el producto. Pero sigue pegada cuando
 * llegas al footer, y el footer de esta tienda mide casi 1500px: te comes
 * pantalla y media de newsletter, enlaces y metodos de pago con una barra
 * negra tapando la parte de abajo. El tema solo la esconde en el ultimo
 * momento, cuando ya no queda nada que tapar.
 *
 * LA REGLA
 * --------
 * Si el footer esta en pantalla, la barra se va. El razonamiento es de venta,
 * no de estetica: quien ha llegado al footer ya paso de largo el boton de
 * comprar y ahora esta buscando otra cosa — la talla, los envios, el
 * contacto. Taparle eso para insistir con el carrito no vende mas, estorba.
 *
 * COMO FALLA
 * ----------
 * Sin este archivo, o si IntersectionObserver no existe, la barra se comporta
 * como venia: visible. Se pierde el arreglo, no la funcion de comprar. Por eso
 * la clase se AÑADE para esconder y no al reves: el estado por defecto del
 * HTML es el que ya funcionaba.
 */
(function () {
  'use strict';

  function init() {
    var barra = document.querySelector('[class*="sticky-atc"]');
    if (!barra) return;                       // no estamos en una ficha

    var pie = document.querySelector('.bfoot') || document.querySelector('footer');
    if (!pie) return;

    if (!('IntersectionObserver' in window)) return;

    /* rootMargin negativo por abajo: no basta con que el footer asome un pixel
       — se aparta cuando ya hay una franja de footer de verdad en pantalla, la
       altura de la propia barra. Asi no parpadea al rozar el borde. */
    var alto = Math.round(barra.getBoundingClientRect().height) || 120;

    var io = new IntersectionObserver(function (entradas) {
      for (var i = 0; i < entradas.length; i++) {
        barra.classList.toggle('baddie-atc-fuera', entradas[i].isIntersecting);
      }
    }, { rootMargin: '0px 0px -' + alto + 'px 0px', threshold: 0 });

    io.observe(pie);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


/* Native Shopify cart submission for product purchase buttons. */
(function () {
  'use strict';
  function submitProduct(event) {
    var target = event.target;
    var button = target.closest && target.closest('[data-add-to-cart]');
    var form = event.type === 'submit' ? target : button && button.form;
    if (!form || !form.matches('form[data-product-form]') ||
        !form.querySelector('[name="id"]') || (button && button.disabled)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    var quantity = form.parentElement.querySelector('[data-quantity-input]');
    var quantityField = form.querySelector('[name="quantity"]');
    if (quantity && quantityField) {
      if (!quantity.reportValidity()) return;
      quantityField.value = quantity.value;
    }
    if (!form.reportValidity()) return;
    HTMLFormElement.prototype.submit.call(form);
  }
  document.addEventListener('click', submitProduct, true);
  document.addEventListener('submit', submitProduct, true);
})();
